import axios from 'axios'

export default {
    getList(fields) {
        const _fields = (
            fields || [
                'id',
                'referralInfo(note,patient(firstName,lastName,dateOfBirth,mobilePhone),insurancePlan(id,name),diagnosis,insuranceNumber,primaryCarePhysician,insuranceGroupNumber,isPrimaryCareOutsideMedmatch,isInsuranceAuthorizationRequired,fromUser(firstName,lastName,designation,avatar(thumb-360,source),specialities(speciality(id,name),subSpeciality(id,name))))',
                'createdDateTime',
                'status',
            ]
        ).join(',')

        const params = {
            _fields,
        }

        return axios.get(`temporary-referrals`, { params })
    },

    get(id, fields) {
        const _fields = (
            fields || [
                'id',
                'referralInfo(patient(firstName,lastName,dateOfBirth,mobilePhone)',
                'diagnosis',
                'insurancePlan(id,name)',
                'facilityServiceTests(name)',
                'fromUser(firstName,lastName,designation,practice(id,practiceType,name,image(thumb-360,source)),avatar(thumb-360,source),specialities(speciality(id,name),subSpeciality(id,name))))',
                'createdDateTime',
                'status',
                'referralId',
            ]
        ).join(',')

        const params = {
            _fields,
        }

        return axios.get(`temporary-referrals/${id}`, { params })
    },

    createReferralsPool() {
        return axios.post('temporary-referrals/referrals-pool')
    },
}
